import "./sectionsCard.css";

const SectionsCard = ({ title, description, className, svgChild }) => {
  return (
    <div className="section-card">
      <div className={className}>
        <div className="text-left" style={{ lineHeight: "normal" }}>
          <h6 className="text-light fs-5 text-underline">{title}</h6>
          {Array.isArray(description) ? (
            <ul className="text-light pl-2">
              {description.map((item, index) => (
                <div key={index}>
                  <li className="mb-1">{item}</li>
                </div>
              ))}
            </ul>
          ) : (
            description
              .split("\n")
              .filter((line) => line.trim() !== "")
              .map((line, index) => (
                <p key={index} className="text-light description">
                  {line.trim()}
                </p>
              ))
          )}
        </div>
      </div>
      <div>{svgChild}</div>
    </div>
  );
};

export default SectionsCard;
